export type CardStatus = "pending" | "running" | "success" | "warning" | "error";

const COPY_ICON =
  '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>';
const CHECK_ICON =
  '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';


export interface CardConfig {
  id: string;
  title: string;
}

const cards: CardConfig[] = [
  { id: "network-type", title: "Network Type" },
  { id: "ip-detection", title: "IP Detection" },
  { id: "dns-check", title: "DNS Resolution" },
  { id: "backend-connectivity", title: "Backend Connectivity" },
  { id: "vpn-detection", title: "VPN/Proxy Detection" },
];

export function initUI(): void {
  const container = document.getElementById("cards")!;
  container.innerHTML = "";

  for (const card of cards) {
    const el = document.createElement("div");
    el.className = "card";
    el.id = `card-${card.id}`;
    el.innerHTML = `
      <div class="card-header">
        <span class="status status-pending" id="status-${card.id}"></span>
        <span class="card-title">${card.title}</span>
      </div>
      <div class="card-body" id="body-${card.id}">Waiting...</div>
    `;
    container.appendChild(el);
  }
}

export function updateCardStatus(id: string, status: CardStatus): void {
  const statusEl = document.getElementById(`status-${id}`);
  if (statusEl) {
    statusEl.className = `status status-${status}`;
  }
}

export function updateCardBody(id: string, html: string): void {
  const bodyEl = document.getElementById(`body-${id}`);
  if (bodyEl) {
    bodyEl.innerHTML = html;
  }
}

export function row(label: string, value: string): string {
  return `<div class="row"><span class="label">${label}</span><span class="value">${value}</span></div>`;
}

export function setReportInfo(text: string, type: "uploading" | "success" | "error" = "uploading"): void {
  const toast = document.getElementById("report-toast");
  const title = document.getElementById("toast-title");
  const detail = document.getElementById("toast-detail");
  if (!toast || !title || !detail) return;

  toast.className = `report-toast visible ${type}`;
  if (type === "uploading") {
    title.textContent = "Uploading...";
    detail.textContent = "";
  } else if (type === "success") {
    title.textContent = "Report Uploaded Successfully";
    detail.innerHTML = "";

    const idSpan = document.createElement("span");
    idSpan.textContent = `Report ID: ${text}`;

    const copyBtn = document.createElement("button");
    copyBtn.type = "button";
    copyBtn.className = "copy-btn";
    copyBtn.title = "Copy Report ID";
    copyBtn.setAttribute("aria-label", "Copy Report ID");
    copyBtn.innerHTML = COPY_ICON;
    copyBtn.onclick = async () => {
      try {
        await navigator.clipboard.writeText(text);
      } catch {
        // Fallback for non-secure contexts
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      copyBtn.innerHTML = CHECK_ICON;
      copyBtn.classList.add("copied");
      copyBtn.title = "Copied!";
      window.setTimeout(() => {
        copyBtn.innerHTML = COPY_ICON;
        copyBtn.classList.remove("copied");
        copyBtn.title = "Copy Report ID";
      }, 1500);
    };

    detail.appendChild(idSpan);
    detail.appendChild(copyBtn);
  } else {
    title.textContent = "Upload Failed";
    detail.textContent = text;
  }
}

export function enableUploadButton(onClick: () => void): void {
  const btn = document.getElementById("btn-upload") as HTMLButtonElement;
  if (btn) {
    btn.disabled = false;
    btn.onclick = onClick;
  }
}
